export default __webpack_public_path__ + "static/media/fanbag.1d516660.svg";